import firebase from 'firebase/app'
import 'firebase/firebase-messaging'
import 'firebase/firestore'
import 'firebase/database'

import { CONFIG } from '../firebase_config'

const firebaseApp = firebase.initializeApp(CONFIG)
export const db = firebaseApp.database()